<div class="container-fluid min-vh-100 p-1 entity-config-page">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mt-2">
      <div class="entity-config-top-hero px-3 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">{{ topBar.title }}</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Review the live structure and flow of this form before publishing changes.
            </p>
          </div>
        </div>
      </div>

      <div class="px-3 px-md-3 pb-3">
        <section class="row entity-config-top-metrics g-3 g-xl-4 align-items-stretch">
          <div class="col-12 mt-2">
            <article class="card border border-purple border-opacity-50 shadow-sm rounded-4 h-100">
              <div class="card-body p-3 p-lg-4 d-flex flex-column gap-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
                  <div class="d-flex align-items-start gap-3">
                    <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-2 px-3 flex-shrink-0">
                      <i class="bi bi-eye fs-3"></i>
                    </div>
                    <div>
                      <div class="text-dark text-x mb-1">{{ formMeta.eyebrow }}</div>
                      <div class="fw-semibold text-dark text-x mb-1">{{ form_name }}</div>
                      <p class="text-secondary text-xs mb-0">
                        Walk through the configured main sections, sub sections, and questions exactly as they will appear in sequence.
                      </p>
                    </div>
                  </div>

                  <router-link
                    :to="{ name: 'CreateSections', query: { form_id: form_id, form_name: form_name } }"
                    class="btn btn-primary-dark rounded-3 text-xs px-3 py-2 shadow-sm"
                  >
                    {{ topBar.exitLabel }}
                  </router-link>
                </div>

                <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-end gap-3">
                  <p class="text-x text-dark mb-0">Main {{ section_title }}</p>
                  <div class="text-secondary small fw-semibold">{{ section_label }}</div>
                </div>
                <div class="progress preview-progress rounded-pill bg-light">
                  <div
                    class="progress-bar preview-progress-bar rounded-pill bg-light"
                    role="progressbar"
                    :style="{ width: section_progress_percent + '%' }"
                    :aria-valuenow="section_progress_percent"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <main>
      <section class="entity-inventory-panel rounded-4 border shadow-sm p-3">
        <section v-if="preview_loading" class="card border-0 shadow-sm rounded-4">
          <div class="card-body p-4 p-md-5 text-secondary">
            Loading preview...
          </div>
        </section>

        <section v-else-if="preview_error" class="card border-0 shadow-sm rounded-4">
          <div class="card-body p-4 p-md-5">
            <div class="alert alert-danger mb-0">{{ preview_error }}</div>
          </div>
        </section>

        <section v-else-if="!active_main_section" class="card border-0 shadow-sm rounded-4">
          <div class="card-body p-4 p-md-5 text-secondary">
            No form structure is available for this form yet.
          </div>
        </section>

        <section v-else class="border-0 rounded-4">
          <div class="card-body px-0 pb-0 pt-1">
            <div class="d-grid gap-4">

              <div
                v-for="(sub_section, sub_section_index) in active_main_section.sub_sections"
                :key="sub_section.id"
                class="entity-row-card border rounded-4 p-4 entity-bg-purple shadow-sm"
              >
                <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
                  <div>
                    <div class="text-uppercase text-dark text-xxs mb-1">
                      Sub Section {{ sub_section_index + 1 }}
                    </div>
                    <p class="text-x fw-bold text-dark mb-1">{{ sub_section.section_name }}</p>
                    <div class="text-secondary small">
                      {{ sub_section.questions.length }} question(s)
                    </div>
                  </div>
                  <span class="badge rounded-pill text-bg-light border text-dark px-3 py-2">
                    {{ sub_section.order_number || sub_section_index + 1 }}
                  </span>
                </div>

                <div v-if="sub_section.questions.length" class="d-grid gap-3">
                  <div
                    v-for="(question, question_index) in sub_section.questions"
                    :key="question.id"
                    class="bg-light rounded-4 border p-3"
                  >
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div class="flex-grow-1">
                        <div class="fw-semibold text-dark mb-1 text-xs">
                          {{ question_index + 1 }}. {{ question.text }}
                        </div>
                        <div v-if="question.type_label" class="text-secondary text-xxs text-uppercase">
                          {{ question.type_label }}
                        </div>

                        <button
                          v-if="question.dependents_count_hint"
                          type="button"
                          class="btn btn-link p-0 text-decoration-none text-xxs fw-semibold mt-2 d-inline-flex align-items-center gap-1"
                          @click="toggle_question_dependents(question)"
                        >
                          <span class="text-primary">
                            dependent question{{ question.dependents_count_hint === 1 ? '' : 's' }}
                          </span>
                          <i class="bi" :class="question.show_dependents ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
                        </button>
                      </div>
                    </div>

                    <div v-if="question.show_dependents" class="mt-3 pt-3 border-top">
                      <div v-if="question.dependents_loading" class="text-secondary text-xxs d-flex align-items-center gap-2">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>Loading dependent questions...</span>
                      </div>

                      <div v-else-if="question.dependent_questions && question.dependent_questions.length" class="d-grid gap-2">
                        <div
                          v-for="(dep, dep_index) in question.dependent_questions"
                          :key="dep.id || dep_index"
                          class="bg-white border rounded-4 p-3"
                        >
                          <div class="d-flex align-items-start justify-content-between gap-2">
                            <div>
                              <div class="fw-semibold text-dark text-xs mb-1">
                                {{ dep.text }}
                              </div>
                              <div v-if="dep.type_label" class="text-secondary text-xxs text-uppercase">
                                {{ dep.type_label }}
                              </div>
                            </div>
                            <span v-if="dep.trigger_condition" class="badge rounded-pill text-bg-light border text-dark text-xxs">
                              Trigger: {{ dep.trigger_condition }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div v-else class="text-secondary text-xxs"></div>
                    </div>
                  </div>
                </div>

                <div v-else class="alert border border-dark border-start border-0 bg-light text-secondary text-xs mb-0 d-flex align-items-center gap-2">
                  <i class="bi bi-info-circle-fill text-primary"></i>
                  <span>No questions have been added to this sub section yet.</span>
                </div>
              </div>

              <div v-if="!active_main_section.sub_sections.length" class="bg-white rounded-4 border shadow-sm p-5 text-center">
                <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
                  <i class="bi bi-diagram-2 fs-3"></i>
                </div>
                <div class="fw-bold mb-1">No Sub Sections Yet</div>
                <div class="text-secondary small">
                  This main section does not have any sub sections yet.
                </div>
              </div>

              

              <div class="d-flex justify-content-between align-items-center pt-2 gap-3 flex-wrap px-1">
                <button
                  type="button"
                  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 text-white"
                  @click="go_to_previous_section"
                  :disabled="active_main_section_index === 0"
                >
                  Previous Section
                </button>

                <button
                  type="button"
                  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 text-white"
                  @click="go_to_next_section"
                  :disabled="active_main_section_index >= total_main_sections - 1"
                >
                  <span>{{ next_button_label }}</span>
                  <i class="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  </div>
</div>
